import {CountTriggerTextViewerCoreOption} from '../type/CountTriggerTextViewerCoreOption.interface';
import {PartialFrameElements} from '../type/PartialFrameElements.interface';
import {fixImageElementSize} from './fixImageElementSize';
import {getPageTextViewerSizes} from './getPageTextViewerSizes';

export function fixImageSizesInContentElement({
  frameElements,
  option,
  isPageTextViewer,
}: {
  frameElements: PartialFrameElements;
  option: CountTriggerTextViewerCoreOption;
  isPageTextViewer: boolean;
}) {
  const {contentElement} = frameElements;
  const imgElements = contentElement.querySelectorAll('img');

  // 페이지넘김 모드일 때 전체 그릴 수 있는 크기의 90% 정도로 최대값을 줍니다.
  // 리디움의 방식을 참고했습니다.
  // https://github.com/readium/readium-shared-js/blob/7f245beba1ed97eaabce0aa5e9cf2f3b23e8f8f6/js/views/reflowable_view.js#L999-L1017
  if (isPageTextViewer) {
    const {columnWidth, contentHeight} = getPageTextViewerSizes(option);
    imgElements.forEach(imgElement => {
      fixImageElementSize({
        imgElement,
        maxWidth: columnWidth * 0.9,
        maxHeight: contentHeight * 0.9,
      });
    });
  }
  // 스크롤 모드일 때는 width가 터무니없이 커지지 않도록 제약만 줍니다.
  else {
    imgElements.forEach(imgElement => {
      imgElement.style.maxWidth = '100%';
    });
  }
}
